import React from 'react';
import { Box, Paper } from '@mui/material';
import MedicalSection from './MedicalSection';
import MedicationTable from './MedicationTable';
import CollapsedSection from './CollapsedSection';

const Medical_HX_Update = () => {
  const [expanded, setExpanded] = React.useState('medications');
  const [showAddMedication, setShowAddMedication] = React.useState(true);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 0,
        overflow: 'auto',
        bgcolor: '#fff',
        p: 0,
       
    width: '100%',
    minHeight: '100%',
    bgcolor: '#FFFFFF'
      }}>
      <MedicalSection
        title="Allergies"
        expanded={expanded === 'allergies'}
        onChange={() =>
          setExpanded(expanded === 'allergies' ? '' : 'allergies')
        }
      />

      <MedicalSection
        title="Medications"
        expanded={expanded === 'medications'}
        onChange={() =>
          setExpanded(expanded === 'medications' ? '' : 'medications')
        }
        onAdd={() => setShowAddMedication(true)}>
        <MedicationTable
          showAddRow={showAddMedication}
          onCancelAdd={() => setShowAddMedication(false)}
        />
      </MedicalSection>

      <MedicalSection title="Social History" />
      <MedicalSection title="Health Maintenance" />
      <MedicalSection title="Vaccination" />
      <MedicalSection title="Family History" />
      <MedicalSection title="Advance Directives" />

      <Box
        sx={{
          position: 'fixed',
          bottom: 24,
          left: '50%',
          transform: 'translateX(-50%)',
          bgcolor: '#212121',
          color: '#fff',
          borderRadius: '10px',
          px: 1.5,
          py: 0.75,
          display: 'flex',
          gap: 2
        }}>
        ‹ ›
      </Box>
    </Paper>
  );
};

export default Medical_HX_Update;
